import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#fixed-position" }),
  /*#__PURE__*/_createTextVNode(" Fixed position ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" The affix component provides two fixed positions: "),
  /*#__PURE__*/_createVNode("code", null, "top"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createVNode("code", null, "bottom"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Offset bottom 20px")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_affix = _resolveComponent("el-affix")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_affix, {
        position: "bottom",
        offset: 20
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code3), 1)
        ]),
        _: 1
      })
    ])
  ]))
}